import React, { Component } from 'react';
import ReactExport from 'react-data-export';
import { Button } from '@progress/kendo-react-buttons';
import moment from 'moment';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class ResourceHolidaysExcel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            resourceHolidaysGrid: null,
            nullData: [{ columns: [], data: [] }],
        };
    }

    componentDidMount() {
        if (this.props.updateData === true) {
            this.populateResourceHolidaysData();
        }
    }

    componentDidUpdate = async() => {
        if (this.props.updateData === true) {
            this.props.dataUpdated();
            await this.populateResourceHolidaysData();
            document.getElementById("resourceHolidaysReport").click();
        }
    }

    populateResourceHolidaysData = async() => {
        let resourceHolidaysData = [];
        const borderStyle = {
            border: {
                top: { style: "thin", color: "000000" },
                right: { style: "thin", color: "000000" },
                bottom: { style: "thin", color: "000000" },
                left: { style: "thin", color: "000000" }
            }
        };

        if (this.props.resourceHolidaysData && this.props.resourceHolidaysData.length > 0) { 
            for (const record of this.props.resourceHolidaysData) {
                resourceHolidaysData.push([
                    {
                        value: record.ResourceId ? String(record.ResourceId) : '',
                        style: borderStyle
                    },
                    {
                        value: record.Resource ? record.Resource : '',
                        style: borderStyle
                    },
                    {
                        value: record.Holiday ? moment(record.Holiday).format('MM-DD-YYYY') : '',
                        style: borderStyle
                    },
                    {
                        value: record.HolidayComment ? record.HolidayComment : '',
                        style: borderStyle
                    },
                    {
                        value: record.Country ? record.Country : '',
                        style: borderStyle
                    }
                ])
            }

            let headerColumns = [
                { value: 'Resource Id',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Resource',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Holiday',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Holiday Comment',  style: {font: { bold: true }, border: borderStyle.border}},
                { value: 'Country',  style: {font: { bold: true }, border: borderStyle.border}},
            ];

            let emptyRow = [];
            for (const row of headerColumns) {
                if (row.value === 'Resource' || row.value === 'Holiday Comment') {
                    let record = { title: '', width: { wpx: 250 } }
                    emptyRow.push(record);   
                } else {
                    let record = { title: '', width: { wpx: 150 } }
                    emptyRow.push(record);   
                }
            }

            const resourceHolidaysGrid = [
                {
                    columns: [
                        {title: `Date Range - ${moment(this.props.startDate).format('MM-DD-YYYY')} to ${moment(this.props.endDate).format('MM-DD-YYYY')}`, width: {wpx: 250}},
                        {title: '', width: {wpx: 150}},
                    ],
                    data: []
                },
                {
                    columns: emptyRow,
                    data: [headerColumns, ...resourceHolidaysData]
                }
            ];
    
            await this.setState({
                resourceHolidaysGrid: resourceHolidaysGrid
            });
        }

    }

    render() {
        return (
            <ExcelFile
                filename={'Resource Holidays - ' + moment(new Date()).format('DD-MMM-YYYY')}
                element={ 
                    <Button id={"resourceHolidaysReport"} className="d-none">
                        {''}
                    </Button>
                }
            >
                <ExcelSheet
                    dataSet={this.state.resourceHolidaysGrid ? this.state.resourceHolidaysGrid : this.state.nullData}
                    name="Resource Holidays"
                />
            </ExcelFile>
        );
    }
}

export default ResourceHolidaysExcel;
